var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { row: "", "justify-center": "" } },
    [
      _c(
        "v-dialog",
        {
          attrs: {
            persistent: "",
            fullscreen: "",
            "hide-overlay": "",
            transition: "dialog-bottom-transition"
          },
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c(
            "v-card",
            [
              !_vm.soloVisualizacion
                ? _c(
                    "v-toolbar",
                    { attrs: { dark: "", color: "primary", fixed: "" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { icon: "", dark: "" },
                          on: {
                            click: function($event) {
                              _vm.dialogConfirmacionClose = true
                            }
                          }
                        },
                        [_c("v-icon", [_vm._v("close")])],
                        1
                      ),
                      _vm.vehiculosAsignados.length >= 0 &&
                      _vm.subflotasAsignados.length > 0
                        ? _c("v-toolbar-title", [
                            _vm._v(
                              "\n          Eliminar asociaciones de la Flota:\n          " +
                                _vm._s(_vm.flota.nombre) +
                                "\n        "
                            )
                          ])
                        : _vm.vehiculosAsignados.length >= 0
                        ? _c("v-toolbar-title", [
                            _vm._v(
                              "\n          Eliminar asociaciones de la Flota:\n          " +
                                _vm._s(_vm.flota.nombre) +
                                "\n        "
                            )
                          ])
                        : _vm.vehiculosAsignados.length >= 0
                        ? _c("v-toolbar-title", [
                            _vm._v(
                              "\n          Eliminar asociaciones de la Flota:\n          " +
                                _vm._s(_vm.flota.nombre) +
                                "\n        "
                            )
                          ])
                        : _vm._e(),
                      _c("v-spacer"),
                      _c(
                        "v-toolbar-items",
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "btn-grabar",
                              attrs: { depressed: "" },
                              on: {
                                click: function($event) {
                                  return _vm.confirmacion()
                                }
                              }
                            },
                            [_vm._v("Guardar y continuar")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.soloVisualizacion
                ? _c(
                    "v-toolbar",
                    { attrs: { dark: "", color: "primary" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { icon: "", dark: "" },
                          on: {
                            click: function($event) {
                              return _vm.closeModal(false)
                            }
                          }
                        },
                        [_c("v-icon", [_vm._v("close")])],
                        1
                      ),
                      _c("v-toolbar-title", [
                        _vm._v("Flota: " + _vm._s(_vm.flota.nombre))
                      ])
                    ],
                    1
                  )
                : _vm._e(),
              _c("br"),
              _c("br"),
              _c("br"),
              _c(
                "div",
                { attrs: { align: "center" } },
                [
                  _c(
                    "v-container",
                    { attrs: { "grid-list-md": "", "text-xs-center": "" } },
                    [
                      _vm.showVehiculosGrid
                        ? _c(
                            "div",
                            [
                              _c(
                                "v-card",
                                [
                                  _c(
                                    "v-layout",
                                    { attrs: { row: "", wrap: "" } },
                                    [
                                      _c(
                                        "div",
                                        { attrs: { align: "left" } },
                                        [
                                          _c(
                                            "v-flex",
                                            { attrs: { md12: "" } },
                                            [
                                              !_vm.soloVisualizacion
                                                ? _c(
                                                    "h2",
                                                    { staticClass: "h2_title" },
                                                    [
                                                      _vm._v(
                                                        "\n                          Desasociar Vehículos\n                    "
                                                      )
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm.soloVisualizacion
                                                ? _c(
                                                    "h2",
                                                    { staticClass: "h2_title" },
                                                    [
                                                      _vm._v(
                                                        "\n                          Vehículos Asociados\n                    "
                                                      )
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _c("br")
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  ),
                                  _c("v-divider"),
                                  _c("br"),
                                  _c(
                                    "v-layout",
                                    { attrs: { row: "", wrap: "" } },
                                    [
                                      _c(
                                        "v-flex",
                                        { attrs: { md12: "" } },
                                        [
                                          _c("ag-grid-vue", {
                                            staticClass: "ag-theme-material",
                                            staticStyle: {
                                              width: "100%",
                                              height: "300px",
                                              "font-family":
                                                "'Asap', sans-serif"
                                            },
                                            attrs: {
                                              columnDefs: _vm.columnDefs,
                                              rowData: _vm.vehiculosAsignados,
                                              rowSelection: "multiple",
                                              rowMultiSelectWithClick: "false",
                                              pagination: "true",
                                              paginationPageSize: "10",
                                              suppressRowClickSelection: "true",
                                              sideBar: _vm.sideBar,
                                              localeText: _vm.localeText,
                                              gridReady: _vm.onGridReady,
                                              suppressCsvExport: true,
                                              suppressExcelExport: true
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.showSubFlotasGrid
                        ? _c(
                            "div",
                            [
                              _c("v-layout", { attrs: { row: "", wrap: "" } }, [
                                _c(
                                  "div",
                                  { attrs: { align: "left" } },
                                  [
                                    _c("v-flex", { attrs: { md12: "" } }, [
                                      _c("h2", { staticClass: "h2_title" }, [
                                        _vm._v("Desasociar Subflotas")
                                      ])
                                    ])
                                  ],
                                  1
                                )
                              ]),
                              _c("v-divider"),
                              _c("br"),
                              _c(
                                "v-layout",
                                { attrs: { row: "", wrap: "" } },
                                [
                                  _c(
                                    "v-flex",
                                    { attrs: { md12: "" } },
                                    [
                                      _c("ag-grid-vue", {
                                        staticClass: "ag-theme-material",
                                        staticStyle: {
                                          width: "100%",
                                          height: "300px",
                                          "font-family": "'Asap', sans-serif"
                                        },
                                        attrs: {
                                          columnDefs: _vm.columnDefsSF,
                                          rowData: _vm.subflotasAsignados,
                                          rowSelection: "multiple",
                                          rowMultiSelectWithClick: "false",
                                          pagination: "true",
                                          paginationPageSize: "10",
                                          suppressRowClickSelection: "true",
                                          sideBar: _vm.sideBarSF,
                                          localeText: _vm.localeText,
                                          gridReady: _vm.onGridReadySF,
                                          suppressCsvExport: true,
                                          suppressExcelExport: true
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ]
                  )
                ],
                1
              ),
              _c("app-confirmacion", {
                attrs: {
                  show: _vm.dialogConfirmacion,
                  titulo: "Confirmación",
                  mensaje: _vm.textoDialog,
                  textoBtnSi: "Aceptar",
                  textoBtnNo: "Cancelar"
                },
                on: {
                  modalConfirmationEmit: function($event) {
                    return _vm.confirmCallback($event)
                  }
                }
              }),
              _c("app-confirmacion", {
                attrs: {
                  show: _vm.dialogConfirmacionClose,
                  titulo: _vm.$t("mensajes.mensajesAbandono.editar.titulo"),
                  mensaje: _vm.$t("mensajes.mensajesAbandono.editar.mensaje"),
                  textoBtnSi: _vm.$t(
                    "mensajes.mensajesAbandono.editar.btnAceptar"
                  ),
                  textoBtnNo: _vm.$t(
                    "mensajes.mensajesAbandono.editar.btnCancelar"
                  )
                },
                on: {
                  modalConfirmationEmit: function($event) {
                    return _vm.confirmCallbackConfirm($event, false)
                  }
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }